import styled from 'styled-components';

export const TopLeft = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 4px;

  background-color: var(--panel-bg-color);
  border: 1px solid #333;
  transform: translate(-50%, -50%);

  cursor: nw-resize;
`;
